/*
 * This file is generated by icons/template.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { COMMON, CommonProps } from '../constants';
import theme from '../theme';
import sizeStyle, { IconSizeProps } from '../lib/iconSize';

const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 512 512" {...props}>
    <path
      d="M480 0H32C14.407 0 0 14.405 0 32v448c0 17.592 14.407 32 32 32h448c17.598 0 32-14.408 32-32V32c0-17.595-14.403-32-32-32zM345.66 308.063c-1.502 29.078-11.316 52.36-27.062 69.764-8.939 9.876-19.877 17.796-32.125 23.826-18.97 9.345-41.313 14.126-65.472 14.126-69.718 0-125-39.298-125-115.407v-90.046c0-75.923 54.815-115.219 124.344-115.391h.5c69 0 123.753 38.454 124.97 112.922v.845c0 2.125-.782 4.124-2.313 5.655-.53.563-1.156 1-1.84 1.36-1.346.763-2.878 1.249-4.502 1.249h-63.315c-1.562 0-3-.517-4.31-1.25-2.19-1.187-3.782-3.126-4.253-5.595-.123-.764-.312-1.5-.466-2.281-.626-3.029-1.345-6.028-2.219-8.89-6.219-17.03-22.5-29.187-41.689-29.187-24.5 0-44.374 19.844-44.374 44.39v83.05c0 24.546 19.875 44.388 44.374 44.388 21.374 0 39.19-15.095 43.438-35.17.062-.16.625-2.925.815-4.157.748-3.938 4.374-6.829 8.622-6.829h63.378c2.436 0 4.685.968 6.374 2.61 1.31 1.358 2.126 3.109 2.281 4.936.029.377-.127 4.487-.157 5.082zm71.217 109c-25.344 0-44.499-20.843-44.499-46.189 0-23.67 19.155-43.36 43.937-43.36 25.345 0 44.5 19.688 44.5 43.36 0 24.78-16.907 46.189-43.938 46.189z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

type Props = CommonProps & IconSizeProps;
const IconC = styled(SvgComponent)<Props>`
  ${sizeStyle}
  ${COMMON}
`;
IconC.defaultProps = {
  theme,
};
IconC.propTypes = { ...sizeStyle.propTypes, ...COMMON.propTypes, theme: PropTypes.object };
IconC.displayName = 'IconC';
export { IconC };
